import { ITasks, User } from '@shared-components/models';
import axios from './axios';

const sendReminder = (user: User | undefined, task?: ITasks) => {
  return axios.post('reminder/task', { user, task });
};
export { sendReminder };
